import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=1b0b4902&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Player.vue?vue&type=style&index=1&id=1b0b4902&lang=scss&scoped=true&"
import style2 from "./Player.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0b4902",
  null
  
)

export default component.exports